import { Box, BoxProps } from '@mui/material'
import { getPxAsRem } from 'shared/utils'

import type { FC } from 'react'

interface QuestionWrapperProps extends BoxProps {}

export const QuestionWrapper: FC<QuestionWrapperProps> = ({ children }) => {
    return (
        <Box
            sx={{
                display: 'inline-flex',
                flexDirection: 'column',
                gap: '1.5rem',
                marginBottom: getPxAsRem(36),
                marginTop: getPxAsRem(28),
                maxWidth: getPxAsRem(500),
                width: '100%',
            }}
        >
            {children}
        </Box>
    )
}
